(function (appComponents) {


	appComponents.controllers.checkoutProfile = function (Components) {
		var checkoutProfile = {};

		checkoutProfile.name = "checkoutProfile";


		Components.getControllerPrototype().extend(checkoutProfile);

		checkoutProfile._checkoutProfileBase = checkoutProfile._getService("checkoutProfileBase");
		checkoutProfile._b2bUnit = checkoutProfile._getService("b2bUnit");
		checkoutProfile._helpers = checkoutProfile._getService("helpers");
		checkoutProfile._modals = checkoutProfile._getService("modals");

		checkoutProfile.views = {
			overview: "overview",
			profileDetails: "profileDetails"
		};

		checkoutProfile.currentView = checkoutProfile.views.overview;

		checkoutProfile.elements = {
			get overview() {
				return $('[pc-container="checkout-profile--view-holder"]');
			},
			get profileDetails() {
				return $('[pc-container="checkout-profile--view-holder"]');
			},
			get goBack() {
				return $("[pc-container='checkout-profile--go-back-btn']");
			},
			get shippingAddressSelector() {
				return $("[pc-container='checkout-profile--shipping-address-selector']");
			},
			get thirdPartyAddressSelector() {
				return $("[pc-container='checkout-profile--third-party-billing-selector']");
			},
			get thirdPartyAddressesModal() {
				return $('[pc-container="checkout-profile--modal-third-party-address"]');
			},
			get shippingAddressSection() {
				return $("[pc-container='checkout-profile--shipping-address-section']");
			},
			get billingAddressSection() {
				return $("[pc-container='checkout-profile--billing-address-section']");
			},
			get addShippingModal() {
				return $('[pc-container="checkout-profile--add-shipping-modal"]');
			},
			get addThirdPartyModal() {
				return $('[pc-container="checkout-profile--add-third-party-billing-modal"]');
			},
		};

		checkoutProfile.bindings = function () {
			checkoutProfile._elements.page.on("click", "[pc-container='checkout-profile--item-delete-btn']", function () {
				var parent = $(this).closest("[pc-container='checkout-profile--item']");
				var itemCode = parent.attr("pc-value");
				checkoutProfile.handlers.onItemDelete(itemCode, parent);
			});
			checkoutProfile._elements.page.on("click", "[pc-container='checkout-profile--item-edit-btn']", function () {
				var itemCode = $(this).closest("[pc-container='checkout-profile--item']").attr("pc-value");
				checkoutProfile.handlers.onItemEdit(itemCode, this);
			});

			checkoutProfile._elements.page.on("change", "[pc-container='checkout-profile--billing-address-selector']", function () {
				checkoutProfile.handlers.onBillingAddressSelect(this.value);
			});
			checkoutProfile._elements.page.on("change", "[pc-container='checkout-profile--shipping-address-selector']", function () {
				checkoutProfile.handlers.onShippingAddressSelect(this.value);
			});

			checkoutProfile._elements.page.on("change", "[pc-container='checkout-profile--shipment-type-selector']", function () {
				checkoutProfile.handlers.onTypeChange(this.value);
			});
			checkoutProfile._elements.page.on("change", "[pc-container='checkout-profile--shipment-method-selector']", function () {
				checkoutProfile.handlers.onMethodChange(this.value);
			});
			checkoutProfile._elements.page.on("change", "[pc-container='checkout-profile--shipment-carrier-selector']", function () {
				checkoutProfile.handlers.onCarrierChange(this.value);
			});
			checkoutProfile._elements.page.on("submit", "[pc-container='checkout-profile--add-shipping-address-form']", function () {
				checkoutProfile.handlers.onShippingAddressSubmit(this);
				return false;
			});
			checkoutProfile._elements.page.on("submit", "[pc-container='checkout-profile--add-third-party-billing-form']", function () {
				checkoutProfile.handlers.onThirdPartyAddressSubmit(this);
				return false;
			});
			checkoutProfile._elements.page.on("click", "[pc-container='checkout-profile--remove-third-party-address']", function () {
				var thirdPartyAddressId = $(this).parent().closest('[pc-container="checkout-profile--item-modal-third-party-address"]').attr("pc-value");
				checkoutProfile.handlers.onThirdPartyAddressRemove(thirdPartyAddressId);
			});

			checkoutProfile._elements.page.on("submit", "[pc-container='checkout-profile--profile-details-form']", function (e) {
				checkoutProfile.handlers.onUpdateProfile(this);
				return false;
			});

			checkoutProfile._elements.page.on("click", "[pc-container='checkout-profile--go-back-btn']", function (e) {
				checkoutProfile.handlers.onGoBack();
			});
		};

		// checkoutProfile.liveBindings = function () {

		// };

		checkoutProfile.populateBillingAddresses = function () {
			return checkoutProfile._api.b2bUnit.getBillingAddresses().then(function (res) {
				if (res && res.status == 200) {
					checkoutProfile.context.billingAddresses = res.body;
				}
			}).fail(function (e) {
				console.log(e);
			});
		};

		checkoutProfile.populateShippingAddresses = function () {
			return checkoutProfile._api.b2bUnit.getShippingAddresses().then(function (res) {
				if (res && res.status == 200) {
					checkoutProfile.context.shippingAddresses = res.body;
				} else {
					console.log(res);
				}
			});
		};

		checkoutProfile.populateThirdPartyAddresses = function () {
			return checkoutProfile._api.orderCheckout.getThirdPartyAddresses().then(function (res) {
				if (res && res.status == 200) {
					if (res.body.thirdPartyAddress.length) {
						checkoutProfile.context.thirdPartyAddresses = res.body.thirdPartyAddress;
					} else {
						checkoutProfile.context.thirdPartyAddresses = checkoutProfile._b2bUnit.thirdPartyAddresses;
					}
				} else {
					console.log(res);
				}
			});
		};

		checkoutProfile.populateShipmentTypes = function () {
			return checkoutProfile._api.orderCheckout.getShipmentTypes().then(function (res) {
				if (res && res.status == 200) {
					checkoutProfile.context.shipmentTypes = res.body;
				} else {
					console.log(res);
				}
			});
		};

		checkoutProfile.populateProfiles = function () {
			return checkoutProfile._checkoutProfileBase.getProfiles().then(function (profiles) {
				if (profiles) {
					checkoutProfile.context.profiles = profiles;
				}
			});
		};

		checkoutProfile.populateInitialContext = function () {

			var defToReturn = $.Deferred();

			var defTypes = checkoutProfile.populateShipmentTypes();
			var defThirdPartyBills = checkoutProfile.populateThirdPartyAddresses();
			var defShipping = checkoutProfile.populateShippingAddresses();
			var defBilling = checkoutProfile.populateBillingAddresses();
			var defProfiles = checkoutProfile.populateProfiles();

			if (checkoutProfile._b2bUnit.isUnitSet) {
				checkoutProfile.context.unitType = checkoutProfile._b2bUnit.currentUnit.unitType;
			}


			$.when(defTypes, defThirdPartyBills, defShipping, defBilling, defProfiles).then(function () {
				defToReturn.resolve();
			});

			return defToReturn;

		};
		checkoutProfile.updateShippingAddresses = function () {
			return checkoutProfile.populateShippingAddresses().then(function () {
				checkoutProfile._renderTemplate("shippingAddressSelector");
				checkoutProfile.selectNewestAddress("shippingAddress");
			});
		};

		checkoutProfile.updateThirdPartyAddresses = function () {
			return checkoutProfile.populateThirdPartyAddresses().then(function () {
				checkoutProfile.renderThirdPartyAddresses();
				checkoutProfile.selectNewestAddress("thirdParty");
			});
		};

		checkoutProfile.renderThirdPartyAddresses = function () {
			checkoutProfile._renderTemplate("thirdPartyAddressSelector");
			checkoutProfile._renderTemplate("thirdPartyAddressesModal");
		};

		checkoutProfile.saveCustomShippingAddress = function (formData) {
			var addressLine = formData.companyName + ", " + formData.line1 + ", " + formData.townCity + ", " + formData.stateRegion + ", " + formData.postcode + ", " + formData.countryIso;
			checkoutProfile.customShippingAddress = {
				companyName: formData.companyName,
				line1: formData.line1,
				formattedAddress: addressLine,
				country: {
					name: formData.countryIso,
				},
				region: {
					name: formData.stateRegion
				},
				town: formData.townCity,
				postalCode: formData.postcode
			};

			var htmlString = "<option value='customShippingAddress'>" + addressLine + "</option>";

			checkoutProfile.elements.shippingAddressSelector.find("option[value='customShippingAddress']").remove();
			checkoutProfile.elements.shippingAddressSelector.append(htmlString);
			checkoutProfile.selectNewestAddress("shippingAddress");
		};

		checkoutProfile.saveCustomThirdPartyAddress = function (formData) {
			var addressLine = formData.companyName + ", " + formData.line1 + ", " + formData.townCity + ", " + formData.stateRegion + ", " + formData.postcode + ", " + formData.countryIso;

			checkoutProfile.customThirdPartyAddress = {
				companyName: formData.companyName,
				line1: formData.line1,
				formattedAddress: addressLine,
				country: {
					name: formData.countryIso,
				},
				region: {
					name: formData.stateRegion
				},
				town: formData.townCity,
				postalCode: formData.postcode
			};

			var htmlString = "<option value='customThirdPartyAddress'>" + addressLine + "</option>";

			checkoutProfile.elements.thirdPartyAddressSelector.find("option[value='customThirdPartyAddress']").remove();
			checkoutProfile.elements.thirdPartyAddressSelector.append(htmlString);
			checkoutProfile.selectNewestAddress("thirdParty");
		};

		checkoutProfile.selectNewestAddress = function (addressType) {
			var selector;
			if (addressType == "shippingAddress") {
				selector = checkoutProfile.elements.shippingAddressSelector;
				if (checkoutProfile.lastShippingId) {
					selector.val(checkoutProfile.lastShippingId);
					checkoutProfile.lastShippingId = null;
				} else {
					selector.find("option").last().prop('selected', true);
				}
			}
			if (addressType == "thirdParty") {
				selector = checkoutProfile.elements.thirdPartyAddressSelector;
				if (checkoutProfile.lastThirdPartyId) {
					selector.val(checkoutProfile.lastThirdPartyId);
					checkoutProfile.lastThirdPartyId = null;
				} else {
					selector.find("option").last().prop('selected', true);
				}
			}
			selector.trigger("change");
		};

		checkoutProfile.applyAdditionalProfileDetails = function () {
			var shipTo = checkoutProfile.context.profile.shipTo;
			var addressString = shipTo.companyName + ", " + shipTo.formattedAddress;
			addressString = addressString.replace(/\s\s+/g, ' ');

			checkoutProfile.elements.shippingAddressSelector.find("option").filter(function () {
				return this.text == addressString;
			}).attr('selected', true);

			var thirdPartyBillTo = checkoutProfile.context.profile.thirdPartyBillTo;

			if (thirdPartyBillTo != null) {
				try {
					addressString = thirdPartyBillTo.companyName + ", " + thirdPartyBillTo.formattedAddress + ", " + thirdPartyBillTo.country.isocode;
					addressString = addressString.replace(/\s\s+/g, ' ');

					checkoutProfile.elements.thirdPartyAddressSelector.find("option").filter(function () {
						return this.text == addressString;
					}).attr('selected', true);
				} catch (e) {
					console.log(e);
				}
			}
		};

		checkoutProfile.renderView = function (viewName) {
			checkoutProfile._renderTemplate(viewName);
			checkoutProfile.currentView = checkoutProfile.views[viewName];
			checkoutProfile._applyScript.base.select2();
			checkoutProfile._applyScript.base.iCheck();

			if (viewName == checkoutProfile.views.profileDetails) {
				checkoutProfile.applyAdditionalProfileDetails();
			}
		};

		//move to separate component
		checkoutProfile.shipment = {
			parent: checkoutProfile,
			elements: {
				get shipmentTypeSelector() {
					return $("select[name='shipmentType']");
				},
				get shipmentMethodSelector() {
					return $("select[name='shipmentMethod']");
				},
				get shipmentCarrierSelector() {
					return $("select[name='shipmentCarrier']");
				},
				get thirdPartySelector() {
					return $("select[name='thirdPartyBillingId']");
				},
				get carrierAccountInput() {
					return $("[name='carrierAccount']");
				},
				get carrierNameInput() {
					return $("[name='carrierName']");
				},

			},
			initShipment: function () {
				var profile = this.parent.context.profile;
				var self = this;
				if (profile.shipPaymentMethod != null) {
					self.elements.shipmentTypeSelector.val(profile.shipPaymentMethod.code).trigger("change");
					setTimeout(function () {
						if (profile.shipMethod != null) {
							self.elements.shipmentMethodSelector.val(profile.shipMethod.code).trigger("change");
							setTimeout(function () {
								if (profile.carrierType != null) {
									self.elements.shipmentCarrierSelector.val(profile.carrierType.code).trigger("change");
									if (profile.carrierCode) {
										self.elements.carrierAccountInput.val(profile.carrierCode);
									}
								}
							}, 500);
						}
					}, 500);
				}
			},
			onUpdateType: function (type) {
				if (!type) return;
				var self = this;
				this.type = type;

				if (type == "PREPAID" || type == "CUSTOMER PICK UP") {
					self.elements.shipmentMethodSelector.val("").trigger("change").closest("div").hide();
					self.elements.thirdPartySelector.val("").trigger("change").closest("div").hide();
					self.elements.shipmentCarrierSelector.val("").trigger("change").closest("div").hide();
					self.elements.carrierAccountInput.val("").closest("div").hide();
					self.elements.carrierNameInput.val("").closest("div").hide();
					return;
				} else if (type == "3RD PARTY") {
					self.elements.shipmentMethodSelector.closest("div").show();
					self.elements.thirdPartySelector.closest("div").show();
					self.elements.shipmentCarrierSelector.closest("div").hide();
					self.elements.carrierAccountInput.closest("div").hide();
					self.elements.carrierNameInput.closest("div").hide();
				} else {
					self.elements.shipmentMethodSelector.closest("div").show();
					self.elements.thirdPartySelector.closest("div").hide();
					self.elements.shipmentCarrierSelector.closest("div").hide();
					self.elements.carrierAccountInput.closest("div").hide();
					self.elements.carrierNameInput.closest("div").hide();
				}

				this.parent._api.orderCheckout.getShipmentMethods(type).then(function (res) {
					if (res && res.status == 200) {
						var context = {
							options: res.body
						};
						var html = self.parent.templates.shipmentMethods(context);
						self.elements.shipmentMethodSelector.html(html);
						self.parent._applyScript.base.select2();
					} else {
						console.log(e);
					}
				});
			},
			onUpdateMethod: function (method) {
				if (!method) return;
				var self = this;
				this.method = method;

				self.elements.shipmentCarrierSelector.closest("div").show();
				if (this.type != "3RD PARTY") {
					self.elements.carrierAccountInput.closest("div").show();
				}

				this.parent._api.orderCheckout.getShipmentCarriers(method).then(function (res) {
					if (res && res.status == 200) {
						var context = {
							options: res.body
						};
						var html = self.parent.templates.shipmentCarriers(context);
						self.elements.shipmentCarrierSelector.html(html);
						self.parent._applyScript.base.select2();
					} else {
						console.log(e);
					}
				});
			},
			onUpdateCarrier: function (carrier) {
				if (carrier == "NO CARRIER SELECTED") {
					this.elements.carrierNameInput.closest("div").show();
				} else {
					this.elements.carrierNameInput.closest("div").hide();
				}
			}
		};

		checkoutProfile.handlers = {
			onUpdateProfile: function (form) {

				var hasErrors = checkoutProfile._helpers.checkFormForErrors(form);
				if (hasErrors) {
					checkoutProfile._modals.error.show(checkoutProfile._messages.formError);
					return;
				}

				var formData = checkoutProfile._utils.getFormData(form);

				var address;
				var dataToSend = {
					profileName: checkoutProfile.context.profile.code,
					orderNotes: formData.orderNotes,
					shippingNotes: formData.shippingNotes,
					savedOrderName: formData.savedOrderName,
					"billTo.id": formData.billingId,
					"shipPaymentMethod.code": formData.shipmentType,
					"shipMethod.code": formData.shipmentMethod,
					"carrierType.code": formData.shipmentCarrier,
					carrierCode: formData.carrierAccount,
				};

				if (dataToSend["carrierType.code"] == "NO CARRIER SELECTED") {
					dataToSend["carrierType.code"] = formData.carrierName;
				}

				if (formData.shippingId == "customShippingAddress" && checkoutProfile.customShippingAddress != null) {
					address = checkoutProfile.customShippingAddress;
					dataToSend["shipTo.companyName"] = address.companyName;
					dataToSend["shipTo.line1"] = address.line1;
					dataToSend["shipTo.postalCode"] = address.postalCode;
					dataToSend["shipTo.town"] = address.town;
					dataToSend["shipTo.country.isocode"] = address.country.name;
					dataToSend["shipTo.region.isocode"] = address.region.name;
				} else if (formData.shippingId) {
					dataToSend["shipTo.id"] = formData.shippingId;
				}

				if (formData.thirdPartyBillingId == "customThirdPartyAddress" && checkoutProfile.customThirdPartyAddress != null) {
					address = checkoutProfile.customThirdPartyAddress;
					dataToSend["paymentAddress.companyName"] = address.companyName;
					dataToSend["paymentAddress.line1"] = address.line1;
					dataToSend["paymentAddress.postalCode"] = address.postalCode;
					dataToSend["paymentAddress.town"] = address.town;
					dataToSend["paymentAddress.country.isocode"] = address.country.name;
					dataToSend["paymentAddress.region.isocode"] = address.region.name;
				} else if (formData.thirdPartyBillingId) {
					dataToSend["paymentAddress.id"] = formData.thirdPartyBillingId;
				}

				checkoutProfile._api.checkoutProfile.updateProfile(dataToSend).then(function (res) {
					if (res && res.status == 200) {
						checkoutProfile.populateProfiles().then(function () {
							checkoutProfile.renderView(checkoutProfile.views.overview);
						});
					} else {
						checkoutProfile._modals.error.show(res.message);
					}
				});
			},
			onShippingAddressSubmit: function (form) {

				var hasErrors = checkoutProfile._helpers.checkFormForErrors(form);
				if (hasErrors) {
					checkoutProfile._modals.error.show(checkoutProfile._messages.formError);
					return;
				}

				var formData = checkoutProfile._utils.getFormData(form);

				if (formData.saveInAddressBook) {
					checkoutProfile._api.orderCheckout.saveShippingAddress(formData).then(function (res) {
						if (res && res.status == 200) {
							checkoutProfile.lastShippingId = res.body.id;
							checkoutProfile.updateShippingAddresses().then(function () {
								checkoutProfile.elements.addShippingModal.modal("hide");
							});
						} else {
							checkoutProfile._modals.error.show(res.message);
						}
					});
				} else {
					checkoutProfile.saveCustomShippingAddress(formData);
					checkoutProfile.elements.addShippingModal.modal("hide");
				}

			},
			onThirdPartyAddressSubmit: function (form) {
				var hasErrors = checkoutProfile._helpers.checkFormForErrors(form);
				if (hasErrors) {
					checkoutProfile._modals.error.show(checkoutProfile._messages.formError);
					return;
				}

				var formData = checkoutProfile._utils.getFormData(form);

				if (formData.saveInAddressBook) {
					checkoutProfile._api.orderCheckout.saveThirdPartyAddress(formData).then(function (res) {
						if (res && res.status == 200) {
							checkoutProfile.thirdPartyAddressId = res.body.id;
							checkoutProfile.updateThirdPartyAddresses().then(function () {
								checkoutProfile.elements.addThirdPartyModal.modal("hide");
							});
						}
					});
				} else {
					checkoutProfile.saveCustomThirdPartyAddress(formData);
					checkoutProfile.elements.addThirdPartyModal.modal("hide");
				}
			},
			onThirdPartyAddressRemove: function (addressId) {
				checkoutProfile._api.orderCheckout.deleteThirdPartyAddress(addressId).then(function (res) {
					if (res && res.status == 200) {
						checkoutProfile.context.thirdPartyAddresses = res.body.thirdPartyAddress;
						checkoutProfile.renderThirdPartyAddresses();
					} else {
						checkoutProfile._modals.error.show(res.message);
					}
				});
			},
			onBillingAddressSelect: function (addressId) {
				checkoutProfile.context.billingAddresses.forEach(function (el) {
					if (el.id == addressId) {
						checkoutProfile.context.selectedBillingAddress = el;
					}
				});
				checkoutProfile._renderTemplate("billingAddressSection", checkoutProfile.context.selectedBillingAddress);
			},
			onShippingAddressSelect: function (addressId) {
				if (addressId == "customShippingAddress") {
					checkoutProfile.context.selectedShippingAddress = checkoutProfile.customShippingAddress;
				} else {
					checkoutProfile.context.shippingAddresses.forEach(function (el) {
						if (el.id == addressId) {
							checkoutProfile.context.selectedShippingAddress = el;
						}
					});
				}
				checkoutProfile._renderTemplate("shippingAddressSection", checkoutProfile.context.selectedShippingAddress);
			},
			onTypeChange: function (type) {
				checkoutProfile.shipment.onUpdateType(type);
			},
			onMethodChange: function (method) {
				checkoutProfile.shipment.onUpdateMethod(method);
			},
			onCarrierChange: function (carrier) {
				checkoutProfile.shipment.onUpdateCarrier(carrier);
			},
			onItemEdit: function (code) {
				checkoutProfile._api.checkoutProfile.getProfile(code).then(function (res) {
					if (res && res.status == 200) {
						checkoutProfile.context.profile = res.body;
						checkoutProfile.renderView(checkoutProfile.views.profileDetails);
						checkoutProfile._helpers.populateCountries("dropship");
						checkoutProfile._helpers.updateCharCountdown();

						checkoutProfile.shipment.initShipment();
					} else {
						checkoutProfile._modals.error(res.message);
					}
				});
			},
			onItemDelete: function (code, element) {
				checkoutProfile._api.checkoutProfile.deleteProfile(code).then(function (res) {
					if (res && res.status == 200) {
						$(element).remove();
						if (res.body.profileCount === 0) {
							checkoutProfile.context.profiles = [];
							checkoutProfile.renderView(checkoutProfile.views.overview);
						}
					} else {
						checkoutProfile._modals.error(res.message);
					}
				});
			},
			onGoBack: function () {
				switch (checkoutProfile.currentView) {
					case "overview":
						checkoutProfile._goToPage(checkoutProfile._pages.index.title);
						break;
					case "profileDetails":
						checkoutProfile.populateProfiles().then(function () {
							checkoutProfile.renderView(checkoutProfile.views.overview);
						});
						break;
				}
			}

		};

		checkoutProfile.init = function () {

			checkoutProfile._renderPageTemplate();

			checkoutProfile.populateInitialContext().then(function () {

				checkoutProfile.renderView(checkoutProfile.views.overview);
				checkoutProfile._bindings();
				checkoutProfile._events.dispatchEvent("controllerInitialized");
			});


		};

		return checkoutProfile;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});